import { locationTargetsOptionKeys } from '@bingads-webui-campaign-react/wizard-shared-components';

import {
  shouldSelectBundleOption,
  getLocationIntent
} from '@bingads-webui-campaign/hotel-common-targets';
import { getSelectionFromCriterions } from '@bingads-webui-campaign-react/boost-contextual-target';
import { RemovedDeviceBidAdjustment } from '../common/constants';

export const CRITERION_LEVEL = {
  AD_GROUP: 'adGroup',
  CAMPAIGN: 'campaign',
};

export const modelToViewModelForTargetCriterions = ({
  model,
  level = CRITERION_LEVEL.AD_GROUP,
  campaignDeviceCriterions = [],
}) => {
  let positiveOdataType = '';
  let negativeOdateType = '';

  if (level === CRITERION_LEVEL.CAMPAIGN) {
    positiveOdataType = '#Model.BiddableCampaignCriterion';
    negativeOdateType = '#Model.NegativeCampaignCriterion';
  } else {
    positiveOdataType = '#Model.BiddableAdGroupCriterion';
    negativeOdateType = '#Model.NegativeAdGroupCriterion';
  }

  const initialDeviceTypes = model.filter(criterion => criterion.Criterion.Type === 'Device')
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.DeviceName,
      bidAdjustment: criterion.CriterionBid.Multiplier,
    }));

  const initialAgeRanges = model.filter(criterion => criterion.Criterion.Type === 'Age' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.AgeRange,
      bidAdjustment: criterion.CriterionBid.Multiplier,
    }));
  const negativeAgeRanges = model.filter(criterion => criterion.Criterion.Type === 'Age' && criterion['@odata.type'] === negativeOdateType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.AgeRange,
    }));

  const initialGenderTypes = model.filter(criterion => criterion.Criterion.Type === 'Gender' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.GenderType,
      bidAdjustment: criterion.CriterionBid.Multiplier,
    }));
  const negativeGenderTYpes = model.filter(criterion => criterion.Criterion.Type === 'Gender' && criterion['@odata.type'] === negativeOdateType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.GenderType,
    }));

  const initialGenreTargets = model.filter(criterion => criterion.Criterion.Type === 'Genre' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.GenreId,
    }));

  const initialIndustryTargets = model.filter(criterion => criterion.Criterion.Type === 'Industry' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.ProfileId,
      BidAdjustment: criterion.CriterionBid.Multiplier,
    }));

  const initialNegativeIndustryTargets = model.filter(criterion => criterion.Criterion.Type === 'Industry' && criterion['@odata.type'] === negativeOdateType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.ProfileId,
    }));

  const initialJobTargets = model.filter(criterion => criterion.Criterion.Type === 'JobFunction' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.ProfileId,
      BidAdjustment: criterion.CriterionBid.Multiplier,
    }));

  const initialNegativeJobTargets = model.filter(criterion => criterion.Criterion.Type === 'JobFunction' && criterion['@odata.type'] === negativeOdateType)
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.ProfileId,
    }));

  const initialCompanyNameTargets = model.filter(criterion => criterion.Criterion.Type === 'CompanyName' && criterion['@odata.type'] === positiveOdataType)
    .map(criterion => ({
      Id: criterion.Id,
      Target: criterion.Criterion.ProfileId,
      Size: criterion.Criterion.Size,
      Industry: criterion.Criterion.Industry,
      Name: criterion.Criterion.CompanyName,
      BidAdjustment: criterion.CriterionBid.Multiplier,
    }));

  const initialNegativeCompanyNameTargets = model.filter(criterion => criterion.Criterion.Type === 'CompanyName' && criterion['@odata.type'] === negativeOdateType)
    .map(criterion => ({
      Id: criterion.Id,
      Target: criterion.Criterion.ProfileId,
      Size: criterion.Criterion.Size,
      Industry: criterion.Criterion.Industry,
      Name: criterion.Criterion.CompanyName,
    }));

  const initialContextualTargets = getSelectionFromCriterions(model.filter(criterion => criterion.Criterion.Type === 'ContextualTargetType'));

  const initialCampaignLevelDeviceTargets = campaignDeviceCriterions.filter(criterion => criterion.Criterion.Type === 'Device')
    .map(criterion => ({
      Id: criterion.Id,
      criterion: criterion.Criterion.DeviceName,
      bidAdjustment: criterion.CriterionBid.Multiplier,
    }));

  const deviceTypes = initialDeviceTypes.filter(device => device.bidAdjustment !== RemovedDeviceBidAdjustment && device.bidAdjustment !== undefined).map(criterion => criterion.criterion);
  const campaignLevelDeviceTargets = initialCampaignLevelDeviceTargets.filter(device => device.bidAdjustment !== RemovedDeviceBidAdjustment && device.bidAdjustment !== undefined).map(criterion => criterion.criterion);

  return {
    initialDeviceTypes,
    deviceTypes,
    initialCampaignLevelDeviceTargets,
    campaignLevelDeviceTargets,
    initialAgeRanges,
    ageRanges: initialAgeRanges.map(criterion => criterion.criterion),
    initialGenderTypes,
    genderTypes: initialGenderTypes.map(criterion => criterion.criterion),
    negativeAgeRanges,
    negativeGenderTYpes,
    initialGenreTargets,
    genreTargets: initialGenreTargets.map(criterion => criterion.criterion),
    initialIndustryTargets,
    industry: initialIndustryTargets.map(criterion => criterion.criterion),
    initialNegativeIndustryTargets,
    negativeIndustry: initialNegativeIndustryTargets.map(criterion => criterion.criterion),
    initialJobTargets,
    jobTargets: initialJobTargets.map(criterion => criterion.criterion),
    initialNegativeJobTargets,
    negativeJobTargets: initialNegativeJobTargets.map(criterion => criterion.criterion),
    initialCompanyNameTargets,
    companyNameTargets: initialCompanyNameTargets,
    initialNegativeCompanyNameTargets,
    negativeCompanyNameTargets: initialNegativeCompanyNameTargets,
    initialContextualTargets,
    contextualTargets: initialContextualTargets,
    deviceTargetingCampaignLevel: deviceTypes.length === 0 || initialDeviceTypes === 0,
  };
};

export const bulkModelToViewModelForLocationTargetsBase = ({
  locationTargetsModel, bundleCountries, level = CRITERION_LEVEL.AD_GROUP,
}) => {
  const locations = locationTargetsModel
    .filter(criterion => criterion.Criterion.Type === 'Radius' || criterion.Criterion.Type === 'Location');
  const intent = locationTargetsModel.find(criterion => criterion.Criterion.Type === 'LocationIntentCriterion');
  const intentId = intent ? intent.Id : null;
  const intentOption = intent ? getLocationIntent(intent.Criterion.LocationIntentCriterion.IntentOption) : null;
  let targetOption = locations.length ? locationTargetsOptionKeys.specific : locationTargetsOptionKeys.everywhere;
  targetOption = shouldSelectBundleOption(bundleCountries, locations) ? locationTargetsOptionKeys.bundleOrDefaultMarket : targetOption;

  const useParentLevel = level === CRITERION_LEVEL.CAMPAIGN ? false : locations.length === 0;

  return {
    locationTargets: {
      currentLevelSettings: {
        initLocations: locations,
        currentLocations: locations,
        targetOption,
        intentId,
        ...intentOption,
      },
      bidMode: false,
      useParentLevel,
    },
  };
};
